// src/translations/footerTranslations.js
export const footerTranslations = {
    en: {
      companyName: "Side Vip Yacht Rental",
      companyDescription: "Experience luxury yachting in the heart of the Turkish Riviera. Your journey to extraordinary maritime adventures begins here.",
      quickLinks: "Quick Links",
      quickLinksItems: {
        home: "Home",
        aboutUs: "About Us",
        ourYachts: "Our Yachts",
        destinations: "Destinations"
      },
      ourServices: "Our Services",
      servicesItems: {
        yachtCharter: "Yacht Charter"
      },
      contactUs: "Contact Us",
      contactInfo: {
        address: "Side Harbour, Side, Apollon Sk., 07600 Manavgat/Antalya",
        phone: "+90 549 537 70 07",
        email: "side.viprental@gmail.com"
      },
      copyright: "© {year} Side Vip Yacht Rental. All rights reserved."
    },
    tr: {
      companyName: "Side Vip Yat Kiralama",
      companyDescription: "Türk Rivierası'nın kalbinde lüks yatçılık deneyimi yaşayın. Olağanüstü deniz maceralarına yolculuğunuz burada başlıyor.",
      quickLinks: "Hızlı Bağlantılar",
      quickLinksItems: {
        home: "Ana Sayfa",
        aboutUs: "Hakkımızda",
        ourYachts: "Yatlarımız",
        destinations: "Destinasyonlar"
      },
      ourServices: "Hizmetlerimiz",
      servicesItems: {
        yachtCharter: "Yat Kiralama"
      },
      contactUs: "Bize Ulaşın",
      contactInfo: {
        address: "Side Limanı, Side, Apollon Sk., 07600 Manavgat/Antalya",
        phone: "+90 549 537 70 07",
        email: "side.viprental@gmail.com"
      },
      copyright: "© {year} Side Vip Yat Kiralama. Tüm hakları saklıdır."
    },
    de: {
      companyName: "Side Vip Yachtverleih",
      companyDescription: "Erleben Sie Luxusyachting im Herzen der Türkischen Riviera. Ihre Reise zu außergewöhnlichen maritimen Abenteuern beginnt hier.",
      quickLinks: "Schnelllinks",
      quickLinksItems: {
        home: "Startseite",
        aboutUs: "Über Uns",
        ourYachts: "Unsere Yachten",
        destinations: "Ziele"
      },
      ourServices: "Unsere Dienstleistungen",
      servicesItems: {
        yachtCharter: "Yachtcharter"
      },
      contactUs: "Kontaktieren Sie uns",
      contactInfo: {
        address: "Side Harbour, Side, Apollon Sk., 07600 Manavgat/Antalya",
        phone: "+90 549 537 70 07",
        email: "side.viprental@gmail.com"
      },
      copyright: "© {year} Side Vip Yachtverleih. Alle Rechte vorbehalten."
    },
    ru: {
      companyName: "Side Vip Аренда яхт",
      companyDescription: "Ощутите роскошь яхтинга в самом сердце Турецкой Ривьеры. Ваше путешествие к необыкновенным морским приключениям начинается здесь.",
      quickLinks: "Быстрые ссылки",
      quickLinksItems: {
        home: "Главная",
        aboutUs: "О нас",
        ourYachts: "Наши яхты",
        destinations: "Направления"
      },
      ourServices: "Наши услуги",
      servicesItems: {
        yachtCharter: "Аренда яхт"
      },
      contactUs: "Свяжитесь с нами",
      contactInfo: {
        address: "Side Harbour, Side, Apollon Sk., 07600 Manavgat/Antalya",
        phone: "+90 549 537 70 07",
        email: "side.viprental@gmail.com"
      },
      copyright: "© {year} Side Vip Аренда яхт. Все права защищены."
    }
  };